import { type CanvasElementFrom } from '@blaze-runtime/engine-domain';

import { type LayoutMigration } from '../../../services/compat/migrations/layout-migration.models';

export const rootV2Migration: LayoutMigration = {
  mode: 'layout',
  description: 'Migrate root element to v2',
  run: (element: CanvasElementFrom<'root'>): void => {
    if (!('props' in element)) {
      (element as CanvasElementFrom<'root'>).props = {} as any;
    }
  },
};
